import React from 'react';
import StoryBar from '../StoryBar';
import { useSectionsVisibility } from '../../hooks/useSectionsVisibility';

// Découvrir — même barre de stories que l'Accueil (mêmes stories, ronds seuls), sans cadre.
// Le bouton « Ajouter » n'apparaît ici que si l'onglet Accueil est masqué par l'admin.
export const DiscoverStoriesRow = () => {
  const { homeHidden } = useSectionsVisibility();
  return (
    <div className="-mx-2" data-testid="discover-stories-row">
      <StoryBar showAdd={homeHidden} testId="discover-story-bar" />
    </div>
  );
};

export default DiscoverStoriesRow;
